<h4>{{ "ONSIP_I18N.BUTTON_COLOR" | translate }}</h4>
<onsip-color-picker
  [defaultColors]="defaultColors"
  [color]="(buttonColor | async)!"
  (colorChange)="toggleColorPicker($event, 'button')"
>
</onsip-color-picker>

<div class="gradient-checkbox">
  <mat-checkbox
    color="primary"
    [checked]="(gradientOverlay | async) === true"
    (change)="toggleGradientOverlay($event.checked)"
  >
    <span>{{ "ONSIP_I18N.GRADIENT_OVERLAY" | translate }}</span>
  </mat-checkbox>
</div>

<h4>{{ "ONSIP_I18N.ACCENT_COLOR" | translate }}</h4>
<onsip-color-picker
  [defaultColors]="defaultColors"
  [color]="(accentColor | async)!"
  (colorChange)="toggleColorPicker($event, 'accent')"
>
</onsip-color-picker>

<h4>{{ "ONSIP_I18N.BUTTON_LOCATION" | translate }}</h4>
<mat-radio-group
  class="button-location-options"
  required="true"
  [(ngModel)]="buttonPosition"
  color="primary"
>
  <mat-radio-button class="location-option" [value]="'left'">
    {{ "ONSIP_I18N.PLACE_ON_LEFT_SIDE_OF_PAGE" | translate }}
  </mat-radio-button>
  <mat-radio-button class="location-option" [value]="'right'">
    {{ "ONSIP_I18N.PLACE_ON_RIGHT_SIDE_OF_PAGE" | translate }}
  </mat-radio-button>
</mat-radio-group>
